import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FieldText } from "@conserveit/blocks";

const ProjectGroupForm = ({ groupKey, groupName, onChange }) => (
  <Fragment>
    <FieldText
      className="group-key"
      name="group_key"
      label="Group Key"
      placeholder="Group Key"
      help="Warning: Group Key must match the Project Key defined in Jira"
      onChange={onChange}
      value={groupKey}
    />

    <FieldText
      className="group-name"
      name="group_name"
      label="Group Name"
      placeholder="Group Name"
      help="Warning: Group Name must match the Project Name defined in Jira"
      onChange={onChange}
      value={groupName}
    />
  </Fragment>
);

ProjectGroupForm.propTypes = {
  groupKey: PropTypes.string,
  groupName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ProjectGroupForm.defaultProps = {
  groupKey: "",
  groupName: "",
};

export default ProjectGroupForm;
